import React, { useEffect } from 'react'
import FAQ from './FAQ'
import { Link } from "react-router-dom";
import { Button } from 'antd';

export default function Thesis(props) {
    useEffect(() => {
        document.title = "Vabis' Literature Services - Literature Proofreading - Proofreading of Thesis/ Dissertation/ Essay";
        window.scrollTo(0, 0);
    }, [])

    return (
        <div className="App">
            <div className="promotion">&#128218;&#128218;  CLAIM 10 PERCENT OFF NOW USING CODE: <b>10OFF</b> , USE IT ON PAYMENT PAGE  &#128218;&#128218;</div>
            <div className="header-wrapper">
                <img
                    src={'/images/shutterstock_2093112805_600.jpg'}
                    srcSet={`/images/shutterstock_2093112805_1200.jpg 4000w`}
                    alt="Thesis/ Dissertation/ Essay"
                    style={{float: 'left', width: '100%'}}
                />

                <div className="header-text">
                    <header>
                        <h1>Proofreading of Thesis/ Dissertation/ Essay</h1>
                    </header>
                    <p>For only &#163;16.50 per 1000 words have your dissertation/ thesis/ essay professionally proofread. Be assured grammar, spellings, paragraph-grouping, punctuations,  and suggestions for alternative appropriate word choice shall be meticulously taken care of.  For dissertations and thesis, the MLA style shall be evaluated and effectively implemented. Undergraduate, postgraduate and PhD thesis and dissertations are welcome as long as they are related to literature.</p>
                    <Link to="/request?service=thesis"><Button type="primary">Request to proofread</Button></Link>
                </div>
            </div>
            <div className="content-wrapper">
                <FAQ topic='thesis' />
                <FAQ topic='general' />
            </div>

        </div>
    )
}
